import * as React from 'react'

export default function Scrollable({ children }) {
    return <div className="polymer-scroll-content">{children}</div>
}
